export default __webpack_public_path__ + "static/media/FamilyNumber2.10e30824.svg";